<template>
  <div class="login-page">
    <div class="box">
      <img :src="Logo" class="logo" />
      <div class="input-item">
        <div class="label">手机号</div>
        <input type="number" v-model="phone" placeholder="请输入手机号" />
      </div>
      <div class="input-item">
        <div class="label">验证码</div>
        <input type="text" v-model="code" placeholder="请输入验证码" />
        <div class="send-code" @click="SendCode">{{ time_tool ? time + 's' : '发送验证码' }}</div>
      </div>
      <div class="login-desc">温馨提醒：未注册账户的手机号，授权时将自动注册且代表您已阅读并同意<span @click="$nav('Common.RichText')">《用户服务协议》</span></div>
      <Btn title="立即登录" @click="LoginAction" />
    </div>
    <img :src="LoginBg" class="login-bg">
    <div class="version">v {{version}}</div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        time: 60,
        time_tool: null,
        phone: '',
        code: '',
        version:this.$Config.version
      }
    },
    methods: {
      // 2.获取验证码
      SendCode () {
        if (!this.time_tool && this.phone) {
          this.$Post('Common.getCode', {
            phone: this.phone
          }).then((res) => {
            this.$ShowToast(res.msg, { icon: 'success' })
            this.time_tool = setInterval(() => {
              this.time--
              if (this.time <= 0) {
                clearInterval(this.time_tool)
                this.time = 60
                this.time_tool = null
              }
            }, 1000)
          })
        }
      },
      // 3.登录
      LoginAction () {
        if (!this.phone && !this.code) {
          this.$ShowToast('请完善信息')
          return
        }
        this.$Post('Common.login', {
          phone: this.phone,
          code: this.code,
          login_code: this.$route.query.code
        }, { successCode: [400, 402, 200] }).then(res => {
          if (res.code === 200) {
            this.$SetStorage('jinquanlai_web_token', res.data.access_token, 'local')
            if (res.data.is_register * 1 === 1) {
              this.$Bus.$emit(this.$EmitType['OpenRegisterSucc'])
            }
            this.GoNav()
          } else if (res.code === 402) {
            this.GetAuthUrl()
          } else {
            this.$ShowToast(res.msg)
          }
        })
      },
      // 4.自动登录
      AutoLogin () {
        this.$Post('Common.autoLogin', {
          login_code: this.$route.query.code
        }, { loading: false, successCode: [400, 402, 200] }).then(res => {
          if (res.code === 200) {
            this.$SetStorage('jinquanlai_web_token', res.data.access_token, 'local')
            if (res.data.is_register * 1 === 1) {
              this.$Bus.$emit(this.$EmitType['OpenRegisterSucc'])
            }
            this.GoNav()
          } else if (res.code === 402) {
            this.GetAuthUrl()
          }
        })
      },
      // 1.获取微信授权链接
      GetAuthUrl () {
        if (this.$route.query.code) {
          return
        }
        this.$Get('Common.getAuthUrl', {
          url: location.origin + '/#/Common/Login'
        }).then((res) => {
          location.href = res.data.url
        })
      },
      // 返回
      GoNav () {
        const url = this.$GetStorage('jql_location')
        if (url) {
          this.$SetStorage('jql_location_back', true).then(() => {
            window.location = url
          })
        } else {
          this.$nav('Common.Home')
        }
        this.$RemoveStorage('jql_location')
      }
    },
    // mounted () {
    //   this.GetAuthUrl()
    // },
    activated () {
      this.GetAuthUrl()
    },
    created () {
      const flag = this.$GetStorage('jql_location_back')
      if (flag) {
        this.$RemoveStorage('jql_location_back')
        this.$nav('Common.Home')
      }
      this.AutoLogin()
    },
    computed: {
      ...SetImage(['Logo', 'LoginBg'])
    }
  }
</script>

<style lang="less" scoped>
  .login-page {
    .version {
      position: absolute;
      bottom: 10px;
      opacity: .5;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-size: .25rem;
      text-align: center
    }
    .p(1rem .35rem 0);
    box-sizing: border-box;
    height: 100vh;
    // .bg(#fff);
    .logo {
      .w(2.34rem);
      display: block;
      .m(0 auto .1rem);
    }
    .box {
      .bg(#fff);
      .br(.2rem);
      .p(.4rem .5rem);
    }
    .login-bg {
      .w(100vw);
      .h(100vh);
      top: 0;
      left: 0;
      position: absolute;
      z-index: -1;
    }
    .input-item {
      .w();
      display: flex;
      align-items: center;
      .h(1rem);
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      .label {
        .w(1.6rem);
        .fz(.3rem);
        .c(#333);
      }
      input {
        flex: 1;
        .fz(.3rem);
      }
      .send-code {
        .fz(.26rem);
        .c(#3c7ef8);
        .w(1.7rem);
        .h(.6rem);
        .flex-cc();
        box-sizing: border-box;
        border: 1px solid #3c7ef8;
        .br(.3rem);
        position: absolute;
        top: 50%;
        .mt(-.3rem);
        right: 0;
      }
    }
    .login-desc {
      .fz(.26rem);
      .c(#999);
      .lh(1.4);
      .m(.2rem 0 .5rem);
      span {
        .c(#3c7ef8);
      }
    }
  }
</style>
